import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[uex-dropdown-menu]',
  host: {
    class: 'uex-dropdown-menu dropdown-menu'
  }
})
export class DropdownMenuDirective {
  constructor(
    private elementRef: ElementRef
  ) { }
}
